import { Component, inject, input, linkedSignal, output, untracked } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { KENDO_SKELETON, LoaderComponent } from '@progress/kendo-angular-indicators';
import { KENDO_CARD, KENDO_LAYOUT } from '@progress/kendo-angular-layout';
import { TransitionMiniDto } from '@unity/clients';
import { IconService } from '@unity/services/icon.service';
import { SurveyModule } from 'survey-angular-ui';
import { SurveyModel } from 'survey-core';
import { StepperSurveySharedComponent } from '../stepper-survey-shared/stepper-survey-shared.component';

@Component({
  selector: 'unity-card-new-survey-shared',
  imports: [
    KENDO_LAYOUT,
    KENDO_SKELETON,
    KENDO_BUTTON,
    KENDO_CARD,
    SurveyModule,
    StepperSurveySharedComponent,
    ReactiveFormsModule,
    LoaderComponent,
  ],
  templateUrl: './card-new-survey-shared.component.html',
  styleUrl: './card-new-survey-shared.component.scss',
})
export class CardNewSurveySharedComponent {
  private readonly iconService = inject(IconService);

  protected saveIcon = this.iconService.saveIcon;
  protected cancelIcon = this.iconService.cancelIcon;

  /* Inputs */
  public readonly $surveyModel = input.required<SurveyModel>({ alias: 'surveyModel' });
  public readonly $transitions = input.required<TransitionMiniDto[]>({ alias: 'transitions' });
  public readonly $isCreating = input.required<boolean>({ alias: 'isCreating' });
  public readonly createEvent = output<TransitionMiniDto>();
  public readonly cancelEvent = output();

  protected readonly $showSubmit = linkedSignal(() => {
    const surveyModel = this.$surveyModel();
    return surveyModel?.PageCount === 1;
  });

  protected handleCreate(transition: TransitionMiniDto) {
    this.createEvent.emit(transition);
  }

  protected handleCancel() {
    this.cancelEvent.emit();
  }

  protected onPageChangeEvent(nextPage: number) {
    const surveyModel = untracked(this.$surveyModel);
    const showSubmit = untracked(this.$showSubmit);
    if (!surveyModel) {
      return;
    }
    const isLastPage = surveyModel.PageCount === nextPage;
    if (isLastPage && !showSubmit) {
      this.$showSubmit.set(true);
      return;
    }
    if (!isLastPage && showSubmit) {
      this.$showSubmit.set(false);
    }
  }
}
